/**
 * Coffee Bean Clicker v2 - Game Core Entry
 */

import { GameCore } from '@app-games/core';
import { createInitialState } from './state.js';
import { actionHandlers } from './actions.js';
import { autoGenerationSystem } from './systems/autoGenerationSystem.js';
import { playTimeSystem } from './systems/playTimeSystem.js';
import { goldenCherrySystem } from './systems/goldenCherrySystem.js';
import { comboSystem } from './systems/comboSystem.js';
import { roastingSystem } from './systems/roastingSystem.js';
import { progressCheckSystem } from './systems/progressCheckSystem.js';
import type { GameState } from './state.js';
import type { GameAction } from './actions.js';

export type { GameState } from './state.js';
export type { GameAction } from './actions.js';
export {
  computeTapPower, computeBPS, computePrestigeGoldenBeans, computeAscensionStarDust,
  computeCurrentStage, computeOfflineEarnings,
  getCritChance, getCritMultiplier, getComboMultiplier, getComboTier,
  getOfflineEfficiency,
  getTapUpgradeCost, getProducerCost, applyCostDiscount,
  canPrestige, canAscend, isProducerUnlocked,
  formatNumber, formatTime,
} from './state.js';
export { TAP_UPGRADES, PRODUCERS, PRESTIGE_UPGRADES, STAR_UPGRADES, VARIETIES, STAGES, COMBO_TIERS, ROAST_ZONES } from './data/upgrades.js';
export { ACHIEVEMENTS } from './data/achievements.js';

export function createGameCore(debug = false) {
  const core = new GameCore<GameState, GameAction>({
    createInitialState,
    debug,
    historySize: 100,
  });

  for (const [type, handler] of Object.entries(actionHandlers)) {
    core.registerAction(type as GameAction['type'], handler as any);
  }

  core.registerSystem(playTimeSystem);
  core.registerSystem(comboSystem);
  core.registerSystem(autoGenerationSystem);
  core.registerSystem(roastingSystem);
  core.registerSystem(goldenCherrySystem);
  core.registerSystem(progressCheckSystem);

  return core;
}
